module.exports = __webpack_public_path__ + "img/bar_adver.png?v=c1516c96";